import { styled } from '@mui/material/styles'

export const TypeLabel = styled('div')`
  margin: 2px 4px 8px;
  font-size: 12px;
  line-height: 18px;
  color: #555F6D;
`

export const TypeBadge = styled('span')`
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-weight: 600;
  color: #1D4ED8;
  background: #E8F0FF;
`

export const OfferCard = styled('div')`
  margin: 12px 4px 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px dashed #BFD3FF;
  border-radius: 10px;
  background: #F7FAFF;
  font-size: 12px;
  line-height: 16px;
  color: #272E35;

  & strong {
    font-weight: 600;
  }

  @media (max-width: 899px) {
    margin: 16px 0 0;
    font-size: 14px;
    line-height: 20px;
  }
`

export const OfferTitle = styled('div')`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #555F6D;
`

export const OfferText = styled('div')`
  color: #555F6D;
`

export const OfferLink = styled('button')`
  align-self: flex-start;
  padding: 0;
  border: none;
  background: transparent;
  font: inherit;
  font-weight: 600;
  color: #1D4ED8;
  cursor: pointer;
`
